import { ModelRule } from 'src/containers/ProjectDiagram/types/data';
import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const addRule = (rule: ModelRule) => (model: Model) => {
  const existingRule = model.modelData.rulesById[rule.id];
  if (existingRule) {
    return;
  }

  setDataProperty<ModelData>(model)(model.modelData, 'rulesById', {
    ...model.modelData.rulesById,
    [rule.id]: rule,
  });
};
